import React, { Fragment, useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';
import { PillRating } from '../../../Constant';

const PillRatingClass = () => {
  const [rating, setRating] = useState(2);
  return (
    <Fragment>
      <Col xl='6' lg='12' md='6'>
        <Card>
          <HeaderCard title={PillRating} />
          <CardBody>
            <div className='rating pill-rating-list'>
              <Rating
                initialRating={rating}
                emptySymbol={['A', 'B', 'C', 'D', 'E'].map((n) => (
                  <span className='pill-rating'>{n}</span>
                ))}
                fullSymbol={['A', 'B', 'C', 'D', 'E'].map((n) => (
                  <span className='pill-rating br-current'>{n}</span>
                ))}
                onClick={(rate) => setRating(rate)}></Rating>{' '}
              <span className='current-rating'>{rating}</span>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default PillRatingClass;
